
import { Input } from "@/components/ui/input";

interface ProfileAgeRangeProps {
  formData: {
    age_range_min: string;
    age_range_max: string;
  };
  onInputChange: (field: string, value: string) => void;
  loading: boolean;
}

export const ProfileAgeRange = ({ formData, onInputChange, loading }: ProfileAgeRangeProps) => {
  return (
    <div>
      <label className="block text-sm font-medium text-ice-white mb-2">
        Age Range:
      </label>
      <div className="grid grid-cols-2 gap-4 items-center">
        <div>
          <Input
            type="number"
            inputMode="numeric"
            pattern="[0-9]*"
            min="18"
            max="99"
            value={formData.age_range_min}
            onChange={(e) => onInputChange('age_range_min', e.target.value)}
            placeholder="Min age"
            disabled={loading}
            className="bg-carbon border-ice-white/20 text-ice-white placeholder:text-ice-white/50"
          />
        </div>
        <div className="flex items-center gap-4">
          <span className="text-sm text-ice-white/70">to</span>
          <Input
            type="number"
            inputMode="numeric"
            pattern="[0-9]*"
            min="18"
            max="99"
            value={formData.age_range_max}
            onChange={(e) => onInputChange('age_range_max', e.target.value)}
            placeholder="Max age"
            disabled={loading}
            className="bg-carbon border-ice-white/20 text-ice-white placeholder:text-ice-white/50"
          />
        </div>
      </div>
    </div>
  );
};
